import { Alert } from '../Bootstrap/Alert';
import { getNameSuggestions } from '../api/dadata';
import { InputNameAutocomplete } from './InputNameAutocomplete';
import { defaultTo } from 'ramda';

export const DadataName = {
	inheritAttrs: false,
	data: () => ({
		suggestion: {},
		visibleAlert: false,
	}),
	async mounted() {
		const query = this.$attrs['default-value'];

		this.suggestion = await getNameSuggestions(query)
			.then(suggestions => suggestions.find(item => item.value === query))
			.then(defaultTo({}));

		this.visibleAlert = true;
	},
	computed: {
		alertMessage: function() {
			const { name, surname } = this.suggestion.data || {};
			/** @type {string[]} */
			const required = [];

			if (!name)
				required.push('имя');

			if (!surname)
				required.push('фамилию');

			if (required.length) {
				let message = 'Необходимо ввести ';

				message += required.join(' и ');

				return message;
			}
		},
	},
	render() {
		return (
			<div>
				<InputNameAutocomplete
					onSelected={ (event, suggestion) => this.suggestion = suggestion }
					label="ФИО"
					customValidity={ this.alertMessage }
					attrs={ this.$attrs }
				/>
				{ (this.visibleAlert && this.alertMessage) ? (
					<Alert type="danger" class="mt-1">
						{ this.alertMessage }
					</Alert>
				) : null }
			</div>
		)
	}
}
